// @flow
import * as React from 'react'

import './Subtitle.scss'

type Props = {
  children: React.Node,
}

export default class Subtitle extends React.Component<Props> {
  render = () => {
    return <div className="Subtitle">{this.props.children}</div>
  }
}
